import { render, staticRenderFns } from "./parkTab.vue?vue&type=template&id=2f99335f&scoped=true&"
import script from "./parkTab.vue?vue&type=script&lang=js&"
export * from "./parkTab.vue?vue&type=script&lang=js&"
import style0 from "./parkTab.vue?vue&type=style&index=0&id=2f99335f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f99335f",
  null
  
)

export default component.exports